import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';

import { buttons } from '@/styles/buttons';
import { popover } from '@/styles/popover';

import { CheckmarkIcon } from '@/ui/Icons/CheckmarkIcon';
import { ChevronDownIcon } from '@/ui/Icons/ChevronDownIcon';
import { SearchIcon } from '@/ui/Icons/SearchIcon';

import { fontStyles } from '../../../styles/typography';
import { NetworkFilter } from '../../Filters/NetworkFilter';
import { FiltersReducerState, timeFilterLabels, timeFilters } from './filtersReducer';

export function LiquiditySourcesFilters({
  values,
  onChange,
}: {
  onChange: (state: FiltersReducerState) => void;
  values: FiltersReducerState;
}) {
  const { base, item } = popover();

  return (
    <div className="flex items-center gap-2">
      <SearchIcon
        height={16}
        width={16}
        className="absolute transform translate-x-[60%] text-token-gray-1600 h-4 px-0"
      />
      <VisuallyHidden>
        <label htmlFor="asset-search">Search by liquidity source</label>
      </VisuallyHidden>
      <input
        type="search"
        id="asset-search"
        value={values.searchTerm}
        placeholder="Search by liquidity source"
        className="w-full h-9 text-sm pl-8 border-none rounded-sm bg-token-gray-100 min-w-[210px] tablet:w-[310px] focus:bg-primitive-basic-white focus:outline-2 focus:outline-token-purple-800 placeholder:text-token-gray-800 [&::-webkit-search-cancel-button]:hidden"
        onChange={(e) => onChange({ ...values, searchTerm: e.target.value })}
      />
      <NetworkFilter
        value={values.networks}
        onChange={(networks) => onChange({ ...values, networks })}
      />
      <DropdownMenu.Root modal={false}>
        <DropdownMenu.Trigger
          className={buttons({
            color: 'gray',
            size: 'small',
            shape: 'rounded',
          })}
        >
          <span>{values.time ? timeFilterLabels[values.time] : 'All time'}</span>
          <span className="flex justify-center ml-2">
            <ChevronDownIcon />
          </span>
        </DropdownMenu.Trigger>
        <DropdownMenu.Portal>
          <DropdownMenu.Content className={base()}>
            {timeFilters.map((time) => {
              return (
                <DropdownMenu.Item
                  key={time.value}
                  className={item()}
                  onClick={() => onChange({ ...values, time: time.value })}
                >
                  <span className={fontStyles({ variant: 'BODY_SM' })}>{time.label}</span>
                  {time.value === values.time && <CheckmarkIcon className="ml-auto" />}
                </DropdownMenu.Item>
              );
            })}
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </div>
  );
}
